/* eslint-disable @typescript-eslint/no-explicit-any */

import { useNavigate, useParams } from "react-router";


const menu=[
  {label:'대회 안내', to:''},
  {label:'신청 목록', to:'registration'},
  {label:'경기 현황', to:'race-view'},
]

export default function GameViewCategory(){
  const params = useParams();
  const navi = useNavigate();

  return(
    <div className="flex font-semibold py-3 px-5">
      {menu.map( (item:any,i:number)=>{
        return (
        <div key={i} className="flex">
          <div className="select-none cursor-pointer" 
            onClick={()=>navi(`/game/${params.game_code}/${item.to}`)}
          >
            {item.label}
          </div> 
          {i<menu.length-1&&<div className="text-zinc-400 px-2">|</div>}
        </div>)
      })}
    </div>
  )
}